import { Controller } from "stimulus";

export default class extends Controller {
  reload() {
    window.setTimeout(function() {
      window.location.reload();
    }, 1000);
  }

  close() {
    window.close();
  }
}
